import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core'
import { TuiButton, TuiIcon } from '@taiga-ui/core'
import { ButtonAppearance } from '@shared/components/ui-kit/button/core/types/button-appearance.type'
import { ButtonSize } from '@shared/components/ui-kit/button/core/types/button-size.type'
import { ButtonType } from '@shared/components/ui-kit/button/core/types/button-type.type'
import { SpreadContentType } from '@shared/components/common/table/core/types/spread-content.type'
import { NgStyle } from '@angular/common'
import { ButtonShapeType } from '@shared/components/ui-kit/button/core/types/button-shape.type'

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TuiButton, TuiIcon, NgStyle],
})
export class ButtonComponent {
	public appearance: InputSignal<ButtonAppearance> = input<ButtonAppearance>('primary')
	public size: InputSignal<ButtonSize> = input<ButtonSize>('xl')
	public type: InputSignal<ButtonType> = input<ButtonType>('button')
	public shape: InputSignal<ButtonShapeType> = input<ButtonShapeType>('rectangle')
	public isDisabled: InputSignal<boolean> = input<boolean>(false)
	public isLoading: InputSignal<boolean> = input<boolean>(false)
	public iconStart: InputSignal<string> = input<string>('')
	public iconEnd: InputSignal<string> = input<string>('')
	public iconSize: InputSignal<string> = input<string>('')
	public spreadContent: InputSignal<SpreadContentType> = input<SpreadContentType>('center')

	public clicked: OutputEmitterRef<PointerEvent> = output<PointerEvent>()

	protected click(event: PointerEvent): void {
		event.stopPropagation()

		this.clicked.emit(event)
	}
}
